import React from 'react';
import '../gral-stylesheets/contourImages.scss';



class ContourImages extends React.Component {  
  render() {
    return ( 
      <div className='template-image-container'>
          <div className='template-image'>
            <img src={this.props.image} alt='imagen' />
          </div>
      </div>
    );
  }
}

export default ContourImages;